import React from "react";
import { Caveat, Container, Headline } from "./styles";
import { useTranslation } from "react-i18next";

interface ICaveatCardProps {
  caveat: string | undefined;
}

const CaveatCard = ({ caveat }: ICaveatCardProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Headline>{t("slotDetails.caveat")}</Headline>

      <Caveat>{caveat}</Caveat>
    </Container>
  );
};

export default CaveatCard;
